import React from 'react';

const About: React.FC = () => {
  return (
    <div className="min-h-screen bg-white text-slate-900">
      <div className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold mb-4">About moujib.com</h1>
        <p className="text-slate-600 mb-8">Last updated: {new Date().toLocaleDateString()}</p>

        <h2 className="text-xl font-semibold mt-8 mb-2">Our Mission</h2>
        <p className="mb-4">
          We help Facebook Page owners protect their communities and build trust by moderating
          comments efficiently and responsibly.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">What We Do</h2>
        <ul className="list-disc ml-6 space-y-2">
          <li>Detect and delete spam where permitted by Facebook APIs.</li>
          <li>Hide unwanted comments from public view.</li>
          <li>Reply publicly or send private replies (DM) to engage with your audience.</li>
          <li>Automate repetitive tasks with rule‑based moderation configured by you.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8 mb-2">How It Works</h2>
        <p className="mb-4">
          You connect your Facebook profile first to discover the Pages you manage, then grant
          additional permissions for each Page you choose to connect. moujib.com only uses the
          permissions necessary to perform the actions you configure.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">Values</h2>
        <ul className="list-disc ml-6 space-y-2">
          <li><strong>Trust</strong>: Clear controls and visibility into automated actions.</li>
          <li><strong>Compliance</strong>: Respect for Facebook platform policies and applicable laws.</li>
          <li><strong>Privacy</strong>: Data minimization and secure handling of tokens and content.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8 mb-2">Contact</h2>
        <p className="mb-4">
          For questions about moujib.com, email us at khalil@moujib.com.
        </p>

        <div className="mt-8">
          <a href="/terms" className="text-primary underline mr-4">Terms</a>
          <a href="/privacy" className="text-primary underline">Privacy</a>
        </div>
      </div>
    </div>
  );
};

export default About;


